(function() {
  function getServingInfo(sizeName) {
    var normalized = String(sizeName || '').toLowerCase();

    if (normalized.includes('small')) return '3-4 servings';
    if (normalized.includes('med')) return '5-6 servings';
    if (normalized.includes('large') || normalized.includes('lg')) return '7-8 servings';

    return '';
  }

  function cleanLabelText(label) {
    var clone = label.cloneNode(true);
    clone.querySelectorAll('.visually-hidden').forEach(function(hidden) {
      hidden.remove();
    });

    return clone.textContent.trim();
  }

  function formatSizeLabels() {
    document.querySelectorAll('variant-radios fieldset.product-form-input').forEach(function(fieldset) {
      var legend = fieldset.querySelector('legend');
      var legendText = legend ? legend.textContent.toLowerCase() : '';

      if (!legendText.includes('size')) return;

      fieldset.querySelectorAll('label.variant-buttons').forEach(function(label) {
        if (label.querySelector('.option-serving-info')) return;

        var originalText = cleanLabelText(label);
        var match = originalText.match(/^(.+?)\s*\((.+?)\)$/);
        var sizeName = match ? match[1].trim() : originalText;
        var servingInfo = match ? match[2].trim() : getServingInfo(sizeName);
        var hidden = label.querySelector('.visually-hidden');

        if (!servingInfo) return;

        label.innerHTML =
          '<span class="option-title">' +
          '<span class="option-size-name">' + sizeName + '</span>' +
          '<span class="option-serving-info">' + servingInfo + '</span>' +
          '</span>';

        if (hidden) label.appendChild(hidden);
      });
    });
  }

  function updateVariantLegends() {
    document.querySelectorAll('variant-radios fieldset.product-form-input').forEach(function(fieldset) {
      var legend = fieldset.querySelector('legend');
      if (!legend) return;

      var legendText = legend.textContent.toLowerCase();
      var labelText = '';

      if (legendText.includes('menu')) {
        labelText = 'Choose a menu:';
      } else if (legendText.includes('size')) {
        labelText = 'Choose a size:';
      }

      if (!labelText) return;

      var firstTextNode = Array.from(legend.childNodes).find(function(node) {
        return node.nodeType === Node.TEXT_NODE && node.textContent.trim();
      });

      if (firstTextNode) {
        firstTextNode.textContent = labelText + ' ';
      } else {
        legend.insertBefore(document.createTextNode(labelText + ' '), legend.firstChild);
      }
    });
  }

  function updateMealOptions() {
    updateVariantLegends();
    formatSizeLabels();
  }

  function scheduleMealOptionUpdate() {
    [0, 50, 150, 300, 600].forEach(function(delay) {
      setTimeout(updateMealOptions, delay);
    });
  }

  function bindVariantRefresh() {
    document.addEventListener('change', function(event) {
      if (event.target.closest('variant-radios, variant-selects')) {
        scheduleMealOptionUpdate();
      }
    });

    if (window.subscribe && window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.variantChange) {
      window.subscribe(window.PUB_SUB_EVENTS.variantChange, function() {
        scheduleMealOptionUpdate();
      });
    }

    var productRoot = document.querySelector('[id^="MainProduct-"]') || document.body;
    var observer = new MutationObserver(function(mutations) {
      var shouldUpdate = mutations.some(function(mutation) {
        return Array.from(mutation.addedNodes).some(function(node) {
          if (node.nodeType !== Node.ELEMENT_NODE) return false;
          return node.matches('variant-radios, variant-selects, fieldset.product-form-input') ||
            node.querySelector('variant-radios, variant-selects, fieldset.product-form-input');
        });
      });

      if (shouldUpdate) scheduleMealOptionUpdate();
    });

    observer.observe(productRoot, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      scheduleMealOptionUpdate();
      bindVariantRefresh();
    });
  } else {
    scheduleMealOptionUpdate();
    bindVariantRefresh();
  }
})();
